import { styled, alpha } from '@mui/material/styles';
import { TableContainer, TableRow } from '@mui/material';

export const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  marginTop: theme.spacing(2),
  border: `1px solid ${alpha(theme.palette.secondary.main, 0.6)}`,
  borderRadius: '4px',
  '& .MuiTable-root': {
    minWidth: 650,
  },
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
  '& > *': {
    borderBottom: 'unset',
  },
}));

export const NoDataRowStyled = styled(TableRow)(() => ({
  '& > *': {
    borderBottom: 'unset',
  },
}));
